import { render, staticRenderFns } from "./ListaTiposSelecao.vue?vue&type=template&id=4f5491ba&scoped=true"
import script from "./ListaTiposSelecao.vue?vue&type=script&lang=js"
export * from "./ListaTiposSelecao.vue?vue&type=script&lang=js"
import style0 from "./ListaTiposSelecao.vue?vue&type=style&index=0&id=4f5491ba&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5491ba",
  null
  
)

export default component.exports